export class Category {
  constructor() {
    this.id = '';
    this.name = '';
    this.parent = null;
    this.priority = 0;
    this.createdBy = '';
  }
}
